import { __ } from './Lang'

export default [
    {
        id: 'smile',
        name: __('Smiles'),
        emojis: [
            { name: [__('sorriso'), 'smile'], emoji: '😀' },
            { name: [__('sorriso envergonhado'), 'smile2'], emoji: '😄' },
            { name: [__('sorriso dentes'), 'smile3'], emoji: '😁' },
            { name: [__('rindo muito'), 'smile4'], emoji: '😂' },
            { name: [__('chorando de rir'), 'smile5'], emoji: '🤣' },
            { name: [__('envergonhado'), 'smile6'], emoji: '😊' },
            { name: [__('anjo'), 'smile7'], emoji: '😇' },
            { name: [__('piscadinha'), 'smile8'], emoji: '😉' },
            { name: [__('apaixonado'), 'smile9'], emoji: '😍' },
            { name: [__('amando'), 'smile10'], emoji: '🥰' },
            { name: [__('beijo'), 'smile11'], emoji: '😘' },
            { name: [__('lingua de fora'), 'smile12'], emoji: '😜' },
            { name: [__('triste'), 'sad'], emoji: '😞' },
            { name: [__('estrelas'), 'smile13'], emoji: '🤩' },
            { name: [__('aniversario'), 'smile14'], emoji: '🥳' },
            { name: [__('sarcastico'), 'smile15'], emoji: '😏' },
            { name: [__('ruim'), 'smile16'], emoji: '😖' },
            { name: [__('emocionado'), 'smile17'], emoji: '🥺' },
            { name: [__('chorando'), 'smile18'], emoji: '😭' },
            { name: [__('bravo'), 'smile19'], emoji: '😡' },
            { name: [__('surpreso'), 'smile20'], emoji: '😱' },
            { name: [__('abraco'), 'smile21'], emoji: '🤗' },
            { name: [__('medo'), 'smile22'], emoji: '😬' },
            { name: [__('sono'), 'smile23'], emoji: '😴' },
            { name: [__('segredo'), 'smile24'], emoji: '🤐' },
            { name: [__('maluco'), 'smile25'], emoji: '🥴' },
            { name: [__('enjoado'), 'smile26'], emoji: '🤢' },
            { name: [__('merda'), 'smile27'], emoji: '💩' },
            { name: [__('mascara'), 'smile28'], emoji: '😷' },
            { name: [__('doente'), 'smile29'], emoji: '🤒' },
            {
                name: [__('rosto com chapéu de festa e comemorando'), 'face with party horn and party hat'],
                emoji: '🥳',
            },
        ],
    },

    {
        id: 'gestos',
        name: __('Gestos'),
        emojis: [
            { name: [__('punho direta'), 'right fist'], emoji: '🤜', skinTones: ['🤜🏻', '🤜🏼', '🤜🏽', '🤜🏾', '🤜🏿'] },
            { name: [__('punho esquerda'), 'left fist'], emoji: '🤛', skinTones: ['🤛🏻', '🤛🏼', '🤛🏽', '🤛🏾', '🤛🏿'] },
            { name: [__('jóia'), 'joia', 'thumbs up'], emoji: '👍', skinTones: ['👍🏻', '👍🏼', '👍🏽', '👍🏾', '👍🏿'] },
            { name: [__('chau'), 'gesto1'], emoji: '👋' },
            { name: [__('chathu'), 'gesto2'], emoji: '🖐' },
            { name: [__('pare'), 'gesto3'], emoji: '✋' },
            { name: [__('spok'), 'gesto4'], emoji: '🖖' },
            { name: [__('mao_ok'), 'gesto5'], emoji: '👌' },
            { name: [__('pequeno'), 'gesto6'], emoji: '🤏' },
            { name: [__('sorte'), 'gesto7'], emoji: '✌️' },
            { name: [__('dedo_cruzado'), 'gesto8'], emoji: '🤞' },
            { name: [__('rock'), 'gesto9'], emoji: '🤟' },
            { name: [__('hang_lose'), 'gesto10'], emoji: '🤙' },
            { name: [__('soco'), 'gesto11'], emoji: '👊' },
            { name: [__('negocio_fechado'), 'gesto12'], emoji: '🤝' },
            { name: [__('por_favor'), 'gesto13'], emoji: '🙏' },
            { name: [__('forca'), 'gesto14'], emoji: '💪' },
            { name: [__('beijo'), 'gesto15'], emoji: '💋' },
            { name: [__('beijo2'), 'gesto16'], emoji: '👄' },
        ],
    },

    {
        id: 'animais',
        name: __('Natureza'),
        emojis: [
            { name: [__('cachorro'), 'animal1'], emoji: '🐶' },
            { name: [__('gato'), 'animal2'], emoji: '🐱' },
            { name: [__('rato'), 'animal3'], emoji: '🐭' },
            { name: [__('roedor'), 'animal4'], emoji: '🐹' },
            { name: [__('coelho'), 'animal5'], emoji: '🐰' },
            { name: [__('raposa'), 'animal6'], emoji: '🦊' },
            { name: [__('urso'), 'animal7'], emoji: '🐻' },
            { name: [__('panda'), 'animal8'], emoji: '🐼' },
            { name: [__('coala'), 'animal9'], emoji: '🐨' },
            { name: [__('tigre'), 'animal10'], emoji: '🐯' },
            { name: [__('boi'), 'animal11'], emoji: '🐮' },
            { name: [__('porco'), 'animal12'], emoji: '🐷' },
            { name: [__('saoo'), 'animal13'], emoji: '🐸' },
            { name: [__('galinha'), 'animal14'], emoji: '🐔' },
            { name: [__('coruja'), 'animal15'], emoji: '🦉' },
            { name: [__('cavalo'), 'animal16'], emoji: '🐴' },
            { name: [__('unicornio'), 'animal17'], emoji: '🦄' },
            { name: [__('joaninha'), 'animal18'], emoji: '🐞' },
            { name: [__('cobra'), 'animal19'], emoji: '🐍' },
            { name: [__('golfinho'), 'animal20'], emoji: '🐬' },
            { name: [__('baleia'), 'animal21'], emoji: '🐳' },
            { name: [__('tubarao'), 'animal22'], emoji: '🦈' },
            { name: [__('borboleta'), 'animal23'], emoji: '🦋' },
            { name: [__('natal'), 'animal24'], emoji: '🎄' },
            { name: [__('trevo'), 'animal25'], emoji: '🍀' },
            { name: [__('outono'), 'animal26'], emoji: '🍂' },
            { name: [__('cocumelo'), 'animal27'], emoji: '🍄' },
            { name: [__('rosa'), 'animal28'], emoji: '🌷' },
            { name: [__('rosa2'), 'animal29'], emoji: '🌹' },
            { name: [__('rosa_despetalada'), 'animal30'], emoji: '🥀' },
            { name: [__('flor'), 'animal31'], emoji: '🌺' },
            { name: [__('flor_2'), 'animal32'], emoji: '🌸' },
            { name: [__('margarida'), 'animal33'], emoji: '🌼' },
            { name: [__('girasol'), 'animal34'], emoji: '🌻' },
            { name: [__('sol'), 'animal35'], emoji: '🌞' },
            { name: [__('lua'), 'animal36'], emoji: '🌝' },
            { name: [__('lua2'), 'animal37'], emoji: '🌛' },
            { name: [__('lua3'), 'animal38'], emoji: '🌜' },
            { name: [__('lua_nova'), 'animal39'], emoji: '🌖' },
            { name: [__('lua_meia'), 'animal40'], emoji: '🌗' },
            { name: [__('lua_pequena'), 'animal41'], emoji: '🌔' },
            { name: [__('globo'), 'animal42'], emoji: '🌎' },
            { name: [__('terra'), 'animal43'], emoji: '🌍' },
            { name: [__('estrela'), 'animal44'], emoji: '⭐️' },
            { name: [__('raio'), 'animal45'], emoji: '⚡️' },
            { name: [__('fogo'), 'animal46'], emoji: '🔥' },
            { name: [__('arco_iris'), 'animal47'], emoji: '🌈' },
            { name: [__('frio'), 'animal48'], emoji: '❄️' },
            { name: [__('neve'), 'animal49'], emoji: '⛄️' },
            { name: [__('vento'), 'animal50'], emoji: '💨' },
            { name: [__('sol'), 'animal51'], emoji: '☀️' },
            { name: [__('nublado'), 'animal52'], emoji: '⛅️' },
            { name: [__('nuvem'), 'animal53'], emoji: '☁️' },
            { name: [__('chuva'), 'animal54'], emoji: '☔️' },
            { name: [__('guarda_chuva'), 'animal55'], emoji: '☂️' },
            { name: [__('gota'), 'animal56'], emoji: '💧' },
            { name: [__('gotas'), 'animal57'], emoji: '💦' },
            { name: [__('onda'), 'animal58'], emoji: '🌊❄️' },
        ],
    },

    {
        id: 'frutas',
        name: __('Frutas'),
        emojis: [
            { name: [__('maca verde'), 'fruta1'], emoji: '🍏' },
            { name: [__('maca'), 'fruta2'], emoji: '🍎' },
            { name: [__('pera'), 'fruta3'], emoji: '🍐' },
            { name: [__('laranja'), 'fruta4'], emoji: '🍊' },
            { name: [__('limao'), 'fruta5'], emoji: '🍋' },
            { name: [__('banana'), 'fruta6'], emoji: '🍌' },
            { name: [__('melancia'), 'fruta7'], emoji: '🍉' },
            { name: [__('uva'), 'fruta8'], emoji: '🍇' },
            { name: [__('morango'), 'fruta9'], emoji: '🍓' },
            { name: [__('jaca'), 'fruta10'], emoji: '🍈' },
            { name: [__('cereja'), 'fruta11'], emoji: '🍒' },
            { name: [__('pessego'), 'fruta12'], emoji: '🍑' },
            { name: [__('manga'), 'fruta13'], emoji: '🥭' },
            { name: [__('abacaxi'), 'fruta14'], emoji: '🍍' },
            { name: [__('coco'), 'fruta15'], emoji: '🥥' },
            { name: [__('kiwi'), 'fruta16'], emoji: '🥝' },
            { name: [__('tomate'), 'fruta17'], emoji: '🍅' },
            { name: [__('beringela'), 'fruta18'], emoji: '🍆' },
            { name: [__('abacate'), 'fruta19'], emoji: '🥑' },
            { name: [__('milho'), 'fruta20'], emoji: '🌽' },
        ],
    },

    {
        id: 'objetos',
        name: __('Objetos'),
        emojis: [
            { name: [__('futebol'), 'objeto1'], emoji: '⚽️' },
            { name: [__('basket'), 'objeto2'], emoji: '🏀' },
            { name: [__('futebol_americano'), 'objeto3'], emoji: '🏈' },
            { name: [__('baseball'), 'objeto4'], emoji: '⚾️' },
            { name: [__('tenis'), 'objeto5'], emoji: '🥎' },
            { name: [__('volei'), 'objeto6'], emoji: '🏐' },
            { name: [__('bola_oito'), 'objeto7'], emoji: '🎱' },
            { name: [__('pipa'), 'objeto8'], emoji: '🪁' },
            { name: [__('judo'), 'objeto9'], emoji: '🥋' },
            { name: [__('skate'), 'objeto10'], emoji: '🛹' },
            { name: [__('circo'), 'objeto11'], emoji: '🎪' },
            { name: [__('trofeu'), 'objeto12'], emoji: '🏆' },
            { name: [__('medalha'), 'objeto13'], emoji: '🥇' },
            { name: [__('medalha'), 'objeto14'], emoji: '🥈' },
            { name: [__('medalha'), 'objeto15'], emoji: '🥉' },
            { name: [__('medalha'), 'objeto16'], emoji: '🏅' },
            { name: [__('ticket'), 'objeto17'], emoji: '🎫' },
            { name: [__('teatro'), 'objeto18'], emoji: '🎭' },
            { name: [__('pintura'), 'objeto19'], emoji: '🎨' },
            { name: [__('alvo'), 'objeto20'], emoji: '🎯' },
            { name: [__('filme'), 'objeto21'], emoji: '🎬' },
            { name: [__('musica'), 'objeto22'], emoji: '🎹' },
            { name: [__('guitarra'), 'objeto23'], emoji: '🎸' },
            { name: [__('banjo'), 'objeto24'], emoji: '🪕' },
            { name: [__('violino'), 'objeto25'], emoji: '🎻' },
            { name: [__('sasofone'), 'objeto26'], emoji: '🎷' },
            { name: [__('trompete'), 'objeto27'], emoji: '🎺' },
            { name: [__('boliche'), 'objeto28'], emoji: '🎳' },
            { name: [__('video_game'), 'objeto29'], emoji: '🎮' },
            { name: [__('quebra_cabeca'), 'objeto30'], emoji: '🧩' },
            { name: [__('talher'), 'objeto31'], emoji: '🍴' },
            { name: [__('champanhe'), 'objeto32'], emoji: '🥂' },
            { name: [__('vinho'), 'objeto33'], emoji: '🍷' },
            { name: [__('chopp'), 'objeto34'], emoji: '🍺' },
            { name: [__('chopp'), 'objeto35'], emoji: '🍻' },
            { name: [__('telefone'), 'objeto36'], emoji: '📞' },
            { name: [__('telefone'), 'objeto37'], emoji: '☎️' },
            { name: [__('alarme'), 'objeto38'], emoji: '⏰' },
            { name: [__('diamante'), 'objeto39'], emoji: '💎' },
            { name: [__('cartao'), 'objeto40'], emoji: '💳' },
        ],
    },

    {
        id: 'outros',
        name: __('Outros'),
        emojis: [
            { name: [__('coracao'), 'outros1'], emoji: '❤️' },
            { name: [__('coracao'), 'outros2'], emoji: '🧡' },
            { name: [__('coracao'), 'outros3'], emoji: '💛' },
            { name: [__('coracao'), 'outros4'], emoji: '💚' },
            { name: [__('coracao'), 'outros5'], emoji: '💙' },
            { name: [__('coracao'), 'outros6'], emoji: '💜' },
            { name: [__('coracao'), 'outros7'], emoji: '🖤' },
            { name: [__('coracao'), 'outros8'], emoji: '🤍' },
            { name: [__('coracao'), 'outros9'], emoji: '🤎' },
            { name: [__('coracao_quebrado'), 'outros10'], emoji: '💔' },
            { name: [__('coracao'), 'outros11'], emoji: '💖' },
            { name: [__('coracao_flexa'), 'outros12'], emoji: '💘' },
            { name: [__('coracao_presente'), 'outros13'], emoji: '💝' },
            { name: [__('toxico'), 'outros14'], emoji: '☢️' },
            { name: [__('toxico'), 'outros15'], emoji: '☣️' },
            { name: [__('x'), 'outros16'], emoji: '❌' },
            { name: [__('circulo'), 'outros17'], emoji: '⭕️' },
            { name: [__('pare'), 'outros18'], emoji: '🛑' },
            { name: [__('proibido'), 'outros19'], emoji: '⛔️' },
            { name: [__('proibido'), 'outros20'], emoji: '🚫' },
            { name: [__('check'), 'outros21'], emoji: '✅' },
            { name: [__('x'), 'outros22'], emoji: '❎' },
            { name: [__('perigo'), 'outros23'], emoji: '⚠️' },
            { name: [__('check'), 'outros24'], emoji: '✔️' },
            { name: [__('check'), 'outros25'], emoji: '☑️' },
            { name: [__('bolinha'), 'outros26'], emoji: '🔘' },
            { name: [__('bolinha'), 'outros27'], emoji: '🔴' },
            { name: [__('bolinha'), 'outros28'], emoji: '🟠' },
            { name: [__('bolinha'), 'outros29'], emoji: '🟡' },
            { name: [__('bolinha'), 'outros30'], emoji: '🟢' },
            { name: [__('bolinha'), 'outros31'], emoji: '🔵' },
            { name: [__('bolinha'), 'outros32'], emoji: '⚫️' },
            { name: [__('bolinha'), 'outros33'], emoji: '⚪️' },
            { name: [__('quadrado'), 'outros34'], emoji: '🟥' },
            { name: [__('quadrado'), 'outros35'], emoji: '🟧' },
            { name: [__('quadrado'), 'outros36'], emoji: '🟨' },
            { name: [__('quadrado'), 'outros37'], emoji: '🟩' },
            { name: [__('quadrado'), 'outros38'], emoji: '🟦' },
            { name: [__('quadrado'), 'outros39'], emoji: '🟪' },
            { name: [__('quadrado'), 'outros40'], emoji: '⬜️' },
            { name: [__('quadrado'), 'outros41'], emoji: '⬛️' },
            { name: [__('alerta'), 'outros42'], emoji: '🔔' },
            { name: [__('alerta_proibido'), 'outros43'], emoji: '🔕' },
            { name: [__('megafone'), 'outros44'], emoji: '📢' },
            { name: [__('chat'), 'outros45'], emoji: '💬' },
            { name: [__('relogio'), 'outros46'], emoji: '🕑' },
            { name: [__('bandeira_arco_iris'), 'outros47'], emoji: '🏳️‍🌈' },
            { name: [__('bandeira_pirata'), 'outros48'], emoji: '🏴‍☠️' },
            { name: [__('bandeira_branca'), 'outros49'], emoji: '🏳️' },
            { name: [__('bandeira_quadriculada'), 'outros50'], emoji: '🏁' },
            { name: [__('pin'), 'outros51'], emoji: '📌' },
            { name: [__('tesoura'), 'outros52'], emoji: '✂️' },
            { name: [__('pin'), 'outros53'], emoji: '📍' },
            { name: [__('caneta'), 'outros54'], emoji: '✒️' },
            { name: [__('papel'), 'outros55'], emoji: '📝' },
            { name: [__('lapiz'), 'outros56'], emoji: '✏️' },
            { name: [__('lupa'), 'outros57'], emoji: '🔎' },
            { name: [__('cadeado'), 'outros58'], emoji: '🔒' },
            { name: [__('grafico'), 'outros59'], emoji: '📈' },
            { name: [__('gráfico'), 'outros63'], emoji: '📊' },
            { name: [__('envelope'), 'outros60'], emoji: '📧' },
            { name: [__('email'), 'outros61'], emoji: '✉️' },
            { name: [__('papel'), 'outros62'], emoji: '📃' },
            { name: [__('ampulheta'), 'outros66'], emoji: '⏳' },
            { name: [__('cronometro'), 'outros65'], emoji: '⏱' },
            { name: [__('busola'), 'outros66'], emoji: '🧭' },
            { name: [__('chave'), 'outros67'], emoji: '🔑' },
        ],
    },
]
